/* eslint-disable import/no-anonymous-default-export */

import axios from "axios";
import globalConfig from "#constants/globalConfig.js";
import { AlertTost } from "#components";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: undefined,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    // if token required then read the login token (ACCESS TOKEN) and pass that to headers
    const token = localStorage.getItem(globalConfig.TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      AlertTost("Session Expired", error);
      console.log("error from token instance ", error.response);
      localStorage.removeItem(globalConfig.TOKEN);
      window.location.reload();
    }
    if (error.response?.status === 403) {
      AlertTost("Forbidden", error);
      localStorage.removeItem(globalConfig.TOKEN);
      localStorage.removeItem(globalConfig.USER_ROLE);
      window.location.reload();
    }

    return Promise.reject(error);
  }
);

export { axiosInstance };
